function showHydrotheekSection() {
  var section = document.getElementById('hydrotheek-section');

  section.classList.remove('is-hidden');
}

function createHydroTheekUrl() {
  var regex = new RegExp('&([a-z])*=', 'gi');
  return window.location.search.replace('?search', '?q').replace(regex, '+AND+');
}

function setHydrotheekButtonUrl(queryUrl) {
  var button = document.getElementById('hydrotheek-button');
  var baseUrl = button.getAttribute('base-url');

  button.setAttribute('href', (baseUrl += queryUrl));
}
